import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { TranslateService } from 'src/app/services/translate/translate.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'aos-app-request-processing-side-panel-title',
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <span>{{ componentTitleData | translate }}</span> `
})
export class RequestProcessingSidePanelTitleComponent {
  readonly translate = inject(TranslateService);

  private readonly defaultComponentTitleData: string =
    TranslateRegistry.get.TWO_WAY_REQUEST_PROCESSING.TITLE.TWO_WAY_REQUEST_PROCESSING;

  private componentTitleDataValue: string = this.defaultComponentTitleData;

  @Input()
  set componentTitleData(value: string | null | undefined) {
    this.componentTitleDataValue = value ?? this.defaultComponentTitleData;
  }

  get componentTitleData(): string {
    return this.componentTitleDataValue;
  }
}
